module.exports = "/_next/static/images/marketingWidgetSticker_en-a80a2b9b1b687a6ec0c84bdd031e2428.png";